import { render, staticRenderFns } from "./BoxActions.vue?vue&type=template&id=634b923c&"
import script from "./BoxActions.vue?vue&type=script&lang=js&"
export * from "./BoxActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports